module.exports = __webpack_public_path__ + "d2af5f86d242eb60e4b7f63d34a8c655.png";